import axios from "axios";
import { configUrl } from "config";

// Create a new enrollment (backend creates user automatically)
export default async function createUserEnrollment(data) {
    try {
        const res = await axios.post(`${configUrl.AssessmentServer}/api/UserProgramEnrollment`, data);
        // backend should return EnrollmentId and created UserId
        return res?.data;
    } catch (err) {
        console.error("Error in createUserEnrollment:", err);
        throw err;
    }
}
